import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function index(props) {
  return (
    <div className="rBreadcrumbs">
      <Link
        className="rBrLinks rNoDecoLink"
        to={`/detail-board/${localStorage.getItem(
          'board_id',
        )}_${localStorage.getItem('board_index')}`}
      >
        {/* {localStorage.getItem("board_name")} */}
        Region Enabler
      </Link>
      <span className="rSeparator mr-2 ml-2">\</span>
      <Link className="rBrLinks rNoDecoLink" href="/business-process/cvc">
        Business Process -
        {' '}
        {props?.page}
      </Link>

      <span className="rSeparator mr-2 ml-2">\</span>
      <a className="rBrLinks rNoDecoLink active" href="#">
        Level 1
      </a>
    </div>
  );
}

export default index;
